import React, { useState, useEffect } from 'react'
import HeaderSales from './common/HeaderSales'
import Footer from './common/Footer'
import registred from '../assets/img/icons/Total Registration.png'
import approved from '../assets/img/icons/Total Approved.png'
import pending_approve from '../assets/img/icons/Reg by SalesMkt Team.png'
import active_plumber from '../assets/img/icons/Total Active Retailers.png'
import inactive_plumber from '../assets/img/icons/Total Inactive Retailers.png'
import scanned_qrcode from '../assets/img/icons/scanned_qrcode.png'
import rejected_scan from '../assets/img/total_rejected.png'
import total_star from '../assets/img/icons/total_star.png'
import redeemstar from '../assets/img/icons/redeemstar.png'
import pendingVerify from '../assets/img/icons/Pending Verification.png'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import * as Constants from "./Constants/index"
import DonutChart from './DonutChart';
import BarChart from './BarChart'
import Oval from '../loader/CircleLoade';
import swal from 'sweetalert'

export default function SalesDashboard() {
  const [isVisible, setIsVisible] = useState(false);
  const [topPlumber, setTopPlumber] = useState([]);
  const [dashboard, setDashboard] = useState({});
  // const [totalMember, setTotalMember] = useState('')
  const [loading, setLoading] = useState(false);

  const userType = localStorage.getItem('user_type');


  useEffect(() => {

    const token = localStorage.getItem('token');
    const language = localStorage.getItem('language') || 'en';

    const headers = {
      Authorization: `Bearer ${token}`,
      "Accept-Language": language,
      platform: Constants.pt,
      appVersion: Constants.av,
      program: Constants.program,
      company: Constants.company,
    };

    const fetchData = async () => {
      window.addEventListener('scroll', handleScroll);
      setLoading(true);

      try {

        const res = await axios.get(Constants.baseUrl + "reports/top10Retailer/list?sortBy=totalPoints&sortAsc=true&limit=10&page=1", { headers });
        if (res.status === 201 && res.data.output) {
          setTopPlumber(res.data.output.results || []);
        }
      } catch (err) {
        console.log('Top plumber fetch error:', err);
      }

      try {
        const res = await axios.get(Constants.baseUrl + 'program/dashboard/sales', { headers });
        if (res.status === 201 && res.data.output) {
          setDashboard(res.data.output || []);
        } else {
          // swal(res.data.msg);
        }
      } catch (err) {
        console.log('Dashboard fetch error:', err);
      }

      setLoading(false);
    };

    fetchData();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  const handleScroll = () => {
    const scrollTop = window.pageYOffset;

    if (scrollTop > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!userType) return;

  return (
    <>
      {loading ? <Oval /> : null}
      <HeaderSales />
      <section className="blog-area pt182">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="all-single-blog">
                <div className="row">
                  <div className="col-md-6 col-xs-12">
                    <div className="cardboard">
                      <div className="row">
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-right border-bottom">
                            <div className="icon">
                              <img src={registred || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">Total Registrations</div>
                              <div className="number count-to">
                                {dashboard.members || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-bottom ">
                            <div className="icon">
                              <img src={pending_approve || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">
                                Reg. by Sales Team
                              </div>
                              <div className="number count-to">
                                {dashboard.newSales || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-bottom  border-right">
                            <div className="icon">
                              <img src={pendingVerify || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">Pending Verification</div>
                              <div className="number count-to">
                                {dashboard.pendingverification || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-bottom ">
                            <div className="icon">
                              <img src={pending_approve || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">Pending Approval</div>
                              <div className="number count-to">
                                {dashboard.memberVerified || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-right">
                            <div className="icon">
                              <img src={inactive_plumber || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">Total Rejections</div>
                              <div className="number count-to">
                                {dashboard.memberRejected || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance">
                            <div className="icon">
                              <img src={approved || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">Total Approved</div>
                              <div className="number count-to">
                                {dashboard.memberApproved || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12">
                    <div className="cardboard">
                      <div className="row">
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-right border-bottom">
                            <div className="icon">
                              <img src={scanned_qrcode || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">Total Code Scan</div>
                              <div className="number count-to">
                                {dashboard.scanTotal || 0}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-bottom">
                            <div className="icon">
                              <img src={scanned_qrcode || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">
                                Total Successful Code Scanned
                              </div>
                              <div className="number count-to">
                                {(dashboard.scanTotal - dashboard.scanRejected) || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-bottom">
                            <div className="icon">
                              <img src={scanned_qrcode || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">
                                Total Code Rejected
                              </div>
                              <div className="number count-to">
                                {dashboard.scanRejected || 0}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-right border-bottom">
                            <div className="icon">
                              <img src={total_star || null} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">
                                Total Points Allocated
                              </div>
                              <div className="number count-to">
                                {dashboard.pointsGiven || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-md-6 padding">
                            <div className="info-box bg-pink hover-expand-effect  lbalance border-bottom">
                              <div className="icon">
                                <img src={redeemstar} alt="" />
                              </div>
                              <div className="content">
                                <div className="text">Total Stars Redeemed</div>
                                <div className="number count-to">
                                  {dashboard.pointsRedeemed || 0}
                                </div>
                              </div>
                            </div>
                          </div> */}
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance border-right">
                            <div className="icon">
                              <img src={active_plumber || null} alt="" />
                            </div>

                            <div className="content">
                              <div className="text">
                                Total Active Retailers
                              </div>
                              <div className="number count-to">
                                {dashboard !== null || dashboard !== undefined
                                  ? dashboard.memberActive
                                  : ""}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 padding">
                          <div className="info-box bg-pink hover-expand-effect  lbalance  ">
                            <div className="icon">
                              <img src={inactive_plumber} alt="" />
                            </div>
                            <div className="content">
                              <div className="text">
                                Total Inactive Retailers
                              </div>
                              <div className="number count-to">
                                {dashboard.memberInActive || 0}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex">
                  {/* <BarChart /> */}
                </div>

                <div className="row mt-30">
                  <div className="col-md-7 col-sm-3 col-xs-12 col-23">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title text-center">
                          Top 10 Retailers
                        </h3>
                      </div>
                      <div className="card-body">
                        <table className="table table-striped  topPlumber mb-0">
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>Name</th>
                              <th>Number</th>
                              <th>Points</th>
                            </tr>
                          </thead>
                          <tbody>
                            {topPlumber &&
                              topPlumber.map(function (item, i) {
                                // const points = item.points >= 1000 ? (item.points / 1000).toLocaleString('en-IN') + ' L' : item.points;
                                return (
                                  <tr key={item.id}>
                                    <td>{i + 1}</td>
                                    <td>{item[0]}</td>
                                    <td>{item[1]}</td>
                                    <td>{item[29]}</td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <DonutChart />
                </div>
                <br />
                <div className="row mt-15 hidden">
                  <div className="col-md-3">
                    <div className="info-box_1 nflink wd80">
                      <Link to="">
                        <div className="info-box-content">
                          <span className="info-box-text">Login Report</span>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="info-box_1 nflink wd80">
                      <Link to="">
                        <div className="info-box-content">
                          <span className="info-box-text">
                            Enrollment Report{" "}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="info-box_1 nflink wd80">
                      <Link to="">
                        <div className="info-box-content">
                          <span className="info-box-text">
                            QR transaction Report
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="info-box_1 nflink wd80">
                      <Link to="">
                        <div className="info-box-content">
                          <span className="info-box-text">
                            Point Summary Report
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="info-box_1 nflink wd80">
                      <Link to="">
                        <div className="info-box-content">
                          <span className="info-box-text">
                            Anomaly Report
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="info-box_1 nflink wd80">
                      <Link to="">
                        <div className="info-box-content">
                          <span className="info-box-text">
                            Blocked Member
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Link
        id="scrollUp"
        to=""
        className={`scroll-to-top-button ${isVisible ? "visible" : "hidden"}`}
        style={{ position: "fixed", zIndex: "2147483647" }}
        onClick={scrollToTop}>
        <FontAwesomeIcon icon={faChevronUp} />
      </Link>
      <Footer />
    </>
  );
}
